<template>
  <div class="flex flex-col relative">
    <div v-for="(row, rowIndex) in rows" :key="rowIndex" class="scroll-container scrollbar-hide" data-scroll-slider>
      <slot name="image" v-for="(image, i) in row" :src="image" :index="i">
        <img
            :key="i"
            class="scroll-image"
            :src="image"
            :alt="`image-${i}`"
        />
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">

import { onMounted } from 'vue'

type Row = string

const {rows} = defineProps<{ rows: Row[][] }>()

onMounted(() => {
  const containers: NodeListOf<HTMLDivElement> = document.querySelectorAll('[data-scroll-slider]')

  window.addEventListener('scroll', () => {
    const viewHeight = window.innerHeight

    containers.forEach((container, i) => {
      const even = i % 2 === 0
      const rect = container.getBoundingClientRect()

      const progress = 1 - (rect.bottom / (rect.height + viewHeight))
      const clamped = Math.min(Math.max(progress, 0), 1)

      const maxScroll = container.scrollWidth - container.clientWidth
      const scrollPos = clamped * maxScroll

      container.scrollLeft = even ? scrollPos : maxScroll - scrollPos
    })
  }, {passive: true})
})

</script>

<style scoped>
@reference "@/assets/css/main.css";

.scroll-container {
  @apply w-screen relative flex items-center gap-1 lg:gap-0 overflow-x-hidden overflow-y-scroll transition-all ease-in-out;
}

.scroll-image {
  @apply relative z-10 flex-shrink-0 max-lg:snap-center w-1/2 lg:w-[23vw] rounded-lg touch-none pointer-events-none transition-all ease-in-out;
}

</style>